export const SEARCH_TERM_QUERY_PARAM = 'query'
